import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//?  English Version
import inviteMembersIntruction1 from "../../assets/img/tutorialimages/addMemberGuide1.png";
import inviteMembersIntruction2 from "../../assets/img/tutorialimages/addMemberGuide2.png";
import inviteMembersIntruction3 from "../../assets/img/tutorialimages/addMemberGuide3.png";
import inviteMembersIntruction4 from "../../assets/img/tutorialimages/addMemberGuide4.png";

//? Japanese Version
import inviteMembersIntruction1Jap from "../../assets/img/tutorialimages/addMemberGuide1_Jap.png";
import inviteMembersIntruction2Jap from "../../assets/img/tutorialimages/addMemberGuide2_Jap.png";
import inviteMembersIntruction3Jap from "../../assets/img/tutorialimages/addMemberGuide3_Jap.png";
import inviteMembersIntruction4Jap from "../../assets/img/tutorialimages/addMemberGuide4_Jap.png";
import inviteMembersIntruction5Jap from "../../assets/img/tutorialimages/addMemberGuide5_Jap.png";

class InviteMemberGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersIntruction1}
            alt="inviteMembersIntruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2}
            alt="inviteMembersIntruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3}
            alt="inviteMembersIntruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4}
            alt="inviteMembersIntruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersIntruction1Jap}
            alt="inviteMembersIntruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2Jap}
            alt="inviteMembersIntruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3Jap}
            alt="inviteMembersIntruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4Jap}
            alt="inviteMembersIntruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />

          <img
            className="imgStyle"
            src={inviteMembersIntruction5Jap}
            alt="inviteMembersIntruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersIntruction1}
            alt="inviteMembersIntruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2}
            alt="inviteMembersIntruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3}
            alt="inviteMembersIntruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4}
            alt="inviteMembersIntruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default InviteMemberGuide;
